module.exports = __webpack_public_path__ + "static/media/IconCalendar.bfd133d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconCalendar.svg
// module id = 935
// module chunks = 0